import { TariffCapacityDisplay, TariffModel } from "@/app/models/tariff.model"

export const getTariffCapacityDisplayMode = (
  tariff: TariffModel,
): TariffCapacityDisplay => {
  return tariff.capacityDisplay ?? TariffCapacityDisplay.FULL
}

export const getTariffFreeAmount = (tariff: TariffModel): number => {
  const free = Number(tariff.free ?? 0)
  return free >= 1 ? free : 0
}

export const isTariffFull = (tariff: TariffModel): boolean => {
  return getTariffFreeAmount(tariff) < 1
}

export const getTariffCapacityClass = (tariff: TariffModel): string => {
  return isTariffFull(tariff) ? "red--text" : "has-text-success"
}

export const getTariffCapacityLabel = (
  tariff: TariffModel,
  options: {
    fullLabel: (freeAmount: number) => string
    binaryLabel: (options: {
      isFull: boolean
      freeAmount: number
      tariff: TariffModel
    }) => string
  },
): string | null => {
  const mode = getTariffCapacityDisplayMode(tariff)
  const freeAmount = getTariffFreeAmount(tariff)

  switch (mode) {
    case TariffCapacityDisplay.HIDDEN:
      return null
    case TariffCapacityDisplay.BINARY:
      return options.binaryLabel({ isFull: freeAmount < 1, freeAmount, tariff })
    case TariffCapacityDisplay.FULL:
      return options.fullLabel(freeAmount)
  }
}
